// extracted by mini-css-extract-plugin
export default {"botaoConfirmar":"fimDeSessaoModal_botaoConfirmar__Klllt"};